import React from 'react'

function PrecioCalidad({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M25.92 40.04l-4.71 5.29c-1.29 1.44-3.41 1.65-4.72.47L2.61 33.33c-1.31-1.18-1.33-3.3-.03-4.74L21.12 7.94c.78-.86 1.89-1.32 2.98-1.22l11.79 1.07c1.37.12 2.44 1.1 2.69 2.45l.87 4.65"
      ></path>
      <path
        fill="#126FFF"
        d="M44.85 26.87l2.17 4.38 4.83.7-3.5 3.41.83 4.81-4.33-2.27-4.32 2.27.83-4.81-3.5-3.41 4.83-.7 2.16-4.38z"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M44.56 47.39c7.34 0 13.29-5.95 13.29-13.29 0-7.34-5.95-13.29-13.29-13.29-7.34 0-13.29 5.95-13.29 13.29 0 7.34 5.95 13.29 13.29 13.29z"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M48.11 52.69l4.78 6.33 2.48-5.91 6.23-.63-6.56-8.78m-10.62 4.09l-8.2 11.23-2.47-5.91-6.23-.63 7.03-9.2"
      ></path>
      <path
        fill="#00033A"
        d="M31.24 17.85a2.44 2.44 0 100-4.88 2.44 2.44 0 000 4.88z"
      ></path>
    </svg>
  )
}

export default PrecioCalidad